import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout/Layout";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function Settings() {
    const [formData, setFormData] = useState({
        orderSyncCount: 0
    });
    const [disableBtn, setDisableBtn] = useState(false);

    const handleInputChange = (eOrVal) => {

        const { name, value } = eOrVal.target;
        setFormData({ ...formData, [name]: value });

    };

    useEffect(() => {
        getContent();
    }, [])

    const getContent = async () => {
        try {
            const token = localStorage.getItem("sansadToken");

            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/setting/get`
            );

            if (response.data.statusCode === 200) {
                setFormData({
                    orderSyncCount: response?.data?.result?.orderSyncCount  || 0
                })
            } else {
                toast.error(response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setDisableBtn(true);

            const token = localStorage.getItem("sansadToken");
            const headers = {
                authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            };
            const formdata = new FormData();
            formdata.append("orderSyncCount", formData.orderSyncCount);

            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/setting/create`,
                formData,
                {
                    headers: headers,
                }
            );
            if (response.data.statusCode === 200) {
                toast.success("Settings updaed successfully!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error(response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (error) {
            console.log(error);
        }
        setDisableBtn(false);
    };

    return (
        <Layout>
            <div>
                <ToastContainer />
                <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl font-medium">Settings</h2>
                    </div>
                    <div className="w-full mt-10">
                        <form action="" className="w-full" onSubmit={handleSubmit}>
                            {/* Email */}
                            <div className="flex flex-col md:flex-row gap-4 mb-4">
                                <div className="w-full md:w-1/2">
                                    <label className="block mb-1 font-medium">Max Order Count</label>
                                    <input
                                        type="number"
                                        min={0}
                                        name="orderSyncCount"
                                        value={formData.orderSyncCount || 0}
                                        onChange={handleInputChange}
                                        className="w-full border rounded-md px-4 py-2"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Submit Button */}
                            <div className="mt-10">
                                <button
                                    type="submit"
                                    className="rounded-md h-[46px] w-full bg-[#2c2c38] text-white hover:bg-[#191919]"
                                    disabled={disableBtn}
                                >
                                    {disableBtn ? "Please Wait ..." : "Save"}
                                </button>
                            </div>

                         
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );

}
